import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { EventStatusEnum, WhatsAppGroupStatusEnum, iEventType } from '../../../../types/eventTypes';
import {
  CorporateEventStatusEnum,
  EventTypeFilterEnum,
} from '../../../../constants/enums';
import ChatHeaderLeftSection from './ChatHeaderLeftSection/ChatHeaderLeftSection';
import ChatHeaderRightSection from './ChatHeaderRightSection/ChatHeaderRightSection';
import { useWhatsAppGroup } from '../../../../hooks/allChatsPageHooks/useWhatsAppGroup';
import { whatsAppModalVariations } from '../../../../utils/content';
import { ICorporateEvent, ICorporateEventMessage } from '../../../../interfaces/corporateEvent';
import { IEventDetailMessages } from '../../../../types/eventTypes';
import JoinWhatsAppGroupModal from '../../join-whatsApp-group-modal/JoinWhatsAppGroupModal';
import './ChatDetailHeader.scss';
import { useAppSelector } from '../../../../hooks/storeHooks';

interface ChatDetailHeaderProps {
  eventDetail: iEventType | ICorporateEvent;
  eventType: EventTypeFilterEnum;
  chatIndex?: number;
  chatMessage: IEventDetailMessages | ICorporateEventMessage;
  handleStatusChange: (status: EventStatusEnum | CorporateEventStatusEnum) => void;
  onBackClick?: () => void;
  onEventStatusChange?: () => void;
  onExclamationClick?: () => void;
}

const ChatDetailHeader: React.FC<ChatDetailHeaderProps> = ({
  eventType,
  eventDetail,
  onBackClick,
  chatIndex = 0,
  onExclamationClick,
  handleStatusChange,
  chatMessage
}) => {
  const whatsAppGroup = useWhatsAppGroup(chatMessage, eventType);
  const { chatsRecord } = useAppSelector((state) => state.chats);
  const selectedEventIndex = chatsRecord?.events?.findIndex(
    (event) => event.eventId === eventDetail?.id
  );

  const handleExclamationClick = () => {
    onExclamationClick?.();
  };

  const isUserPrivacyEnabled = useMemo(() => {
    // Simplified check - can be enhanced later with actual vendor WhatsApp numbers
    if (whatsAppGroup.whatsAppGroupDetails && 'participants' in whatsAppGroup.whatsAppGroupDetails) {
      return false; // For now, assume privacy is not enabled
    }
    return true;
  }, [whatsAppGroup.whatsAppGroupDetails]);

  const whatsAppGroupDetails = whatsAppGroup.whatsAppGroupDetails;

  const showWhatsAppIcon = useMemo(() => {
    if (
      whatsAppGroup.whatsAppGroupDetails !== null &&
      whatsAppGroup.whatsAppGroupDetails !== undefined &&
      whatsAppGroup.whatsAppGroupDetails.groupStatus === WhatsAppGroupStatusEnum.active
    ) {
      return true;
    }
    return false;
  }, [whatsAppGroup.whatsAppGroupDetails]);

  return (
    <Box className="chatDetailHeader">
      <Box className="chatDetailHeaderContent">
        <ChatHeaderLeftSection chatMessage={chatMessage} eventDetail={eventDetail} onBackClick={onBackClick} chatIndex={selectedEventIndex} />
        <ChatHeaderRightSection
          onWhatsAppClick={whatsAppGroup.handleWhatsAppClick}
          onExclamationClick={handleExclamationClick}
          showWhatsAppIcon={showWhatsAppIcon}
        />
      </Box>

      <JoinWhatsAppGroupModal
        buttonText={
          isUserPrivacyEnabled
            ? whatsAppModalVariations.joinGroup
            : whatsAppModalVariations.copyGroupNameBTNText
        }
        heading={whatsAppModalVariations.chatOnWhatsApp}
        subheading={whatsAppModalVariations.aGroupCalled}
        middleText={whatsAppGroupDetails?.name ?? ""}
        endingText={
          isUserPrivacyEnabled
            ? whatsAppModalVariations.privacyEnabled.replace(
              "{codeBlock}",
              "<span style='font-weight:500;'>privacy settings</span>",
            )
            : whatsAppModalVariations.copyGroupNameText
        }
        closeModal={whatsAppGroup.closeWhatsAppModal}
        openWhatsAppModal={whatsAppGroup.isWhatsAppModalOpen}
        disclaimer={!isUserPrivacyEnabled ? whatsAppModalVariations.ifYouHaveMoreThenOne : ""}
        onClickJoinWhatsApp={() => {
          if (whatsAppGroupDetails?.name) {
            navigator.clipboard.writeText(whatsAppGroupDetails.name);
            window.open(whatsAppGroup.whatsAppGroupLink || whatsAppGroupDetails.invitationLink, '_blank');
          }
        }}
      />
    </Box>
  );
};

export default ChatDetailHeader;
